<template>
  <header class="top-menu-phone">
    <div class="top-menu-phone__brand">OpenAS2</div>
    <el-button circle plain icon="el-icon-s-operation" @click="openSidemenu" />

    <el-drawer
      :visible.sync="drawerVisible"
      direction="ltr"
      size="80%"
      custom-class="top-menu-phone__drawer"
      @close="closedMenuMovil"
    >
      <div class="top-menu-phone__drawer-content">
        <div class="top-menu-phone__user-card">
          <el-avatar size="medium">{{ abbreviationName }}</el-avatar>
          <div>
            <div class="top-menu-phone__username">{{ userName }}</div>
            <div class="top-menu-phone__caption">Authenticated session</div>
          </div>
        </div>

        <div class="top-menu-phone__links">
          <router-link
            v-for="route in routes"
            :key="route.path"
            :to="route.path"
            class="top-menu-phone__link"
            @click.native="handleNavigate"
          >
            {{ route.name }}
          </router-link>
        </div>

        <el-button type="danger" plain @click="logout">Sign out</el-button>
      </div>
    </el-drawer>
  </header>
</template>

<script>
import store from '../store'
import router from '../routes'

export default {
  name: 'top-menu-phone',
  props: {
    closedMenuMovil: {
      require: false,
    },
    openSidemenu: {
      require: false,
    },
    showMenu: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      routes: router.options.routes.filter((e) => (e.meta != null ? e.meta.sidemenu : false)),
    }
  },
  computed: {
    drawerVisible: {
      get() {
        return this.showMenu
      },
      set(value) {
        if (value !== this.showMenu && this.closedMenuMovil) {
          this.closedMenuMovil()
        }
      },
    },
    userName() {
      return store.state.username || ''
    },
    abbreviationName() {
      return (store.state.username || 'NA').substr(0, 2).toUpperCase()
    },
  },
  methods: {
    handleNavigate() {
      if (this.closedMenuMovil) this.closedMenuMovil()
    },
    logout: function (e) {
      if (e && e.preventDefault) e.preventDefault()
      store.dispatch('logoutAction', {})
      if (this.closedMenuMovil && this.showMenu) this.closedMenuMovil()
    },
  },
}
</script>

<style scoped>
.top-menu-phone {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  background: #ffffff;
  color: #303133;
  border-bottom: 1px solid #ebeef5;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
}

.top-menu-phone__brand {
  font-size: 20px;
  font-weight: 700;
}

.top-menu-phone__drawer-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.top-menu-phone__user-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebeef5;
}

.top-menu-phone__username {
  font-weight: 600;
}

.top-menu-phone__caption {
  font-size: 12px;
  color: #909399;
}

.top-menu-phone__links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.top-menu-phone__link {
  padding: 12px 14px;
  border-radius: 10px;
  color: #303133;
  text-decoration: none;
  background: #f5f7fa;
}

.top-menu-phone__link.router-link-exact-active {
  color: #409eff;
  background: #ecf5ff;
}
</style>
